import React from "react";
import { useEventContext } from "../../context/EventContext";
import { useUserContext } from "../../context/UserContext";
import { useCommentsContext } from "../../context/CommentsContext";
import { useStreamContext } from "../../context/StreamContext";
import CommentMessages from "../../components/CommentMessages";
import { CPreloader } from "../../components/UI";
import "./style.scss";

export default ({ moduleRef, keyboardShowHandler }) => {
    const { event } = useEventContext();
    const { user } = useUserContext();
    const { stream } = useStreamContext();
    const {
        enabled,
        roomKey,
        flattenedMessages,
        fixedMessages,
        unreadParentMessages,
        unreadChildrenMessages,
        updateMessage,
        isLoading,
        getMessagesMore,
        hasMore,
        isLoadingMore,
        onReadMessageId,
        onReadAll,
        unreadMessagesInThread,
        anonymous,
        setAnonymous,
        saveMessageText,
        onChangeMessageText,
        scrollData,
        scrollAtStart,
        updateScrollData,
    } = useCommentsContext();

    if (!enabled) {
        return null;
    }

    const { maxMessageLength, likesEnabled, dislikesEnabled, avatarsDisabled } = event.moduleComment;

    return (
        <>
            {isLoading
                ? <CPreloader />
                : <CommentMessages
                    event={event}
                    stream={stream}
                    roomKey={roomKey}
                    flattenedMessages={flattenedMessages}
                    fixedMessages={fixedMessages}
                    unreadParentMessages={unreadParentMessages}
                    unreadChildrenMessages={unreadChildrenMessages}
                    updateMessage={updateMessage}
                    likesEnabled={likesEnabled}
                    dislikesEnabled={dislikesEnabled}
                    avatarsDisabled={avatarsDisabled}
                    allowAnonymousMessage={event.moduleComment.allowAnonymousMessage}
                    currentUser={user}
                    maxMessageLength={maxMessageLength}
                    moduleRef={moduleRef}
                    getMessagesMore={getMessagesMore}
                    hasMore={hasMore}
                    isLoadingMore={isLoadingMore}
                    onReadMessageId={onReadMessageId}
                    onReadAll={onReadAll}
                    unreadMessagesInThread={unreadMessagesInThread}
                    anonymous={anonymous}
                    setAnonymous={setAnonymous}
                    saveMessageText={saveMessageText}
                    onChangeMessageText={onChangeMessageText}
                    keyboardShowHandler={keyboardShowHandler}
                    scrollData={scrollData}
                    scrollAtStart={scrollAtStart}
                    updateScrollData={updateScrollData}
                />
            }
        </>
    );
}
